// IMPORT COMPONENTS
/*
 * Chemin relatif au fichier dans lequel on est
 * Ex : import {utils} from '../components/_utils';
 */
//import { utils } from "../components/_utils";


const frontPage = {
    readyFn: function () {
        let self = this;
        self.frontPageInit();
    },

    frontPageInit: function () {
        $("#front-page .section_deux .cell").hover(function () {
            $(this).toggleClass("hovered");
        }, function () {
            $(this).toggleClass("hovered");
        });
    },

};

export { frontPage };
